import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-light-note",
  "use": "fi-icon-light-note-usage",
  "viewBox": "0 0 15.75 15.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.75 15.75\" id=\"fi-icon-light-note\"><path d=\"M15.75-3.512v-9.426a1.687,1.687,0,0,0-1.687-1.687H1.687A1.687,1.687,0,0,0,0-12.937V-.563A1.687,1.687,0,0,0,1.687,1.125h9.426A1.683,1.683,0,0,0,12.307.63l2.949-2.949A1.683,1.683,0,0,0,15.75-3.512ZM11.25-.7V-3.375h2.676Zm2.812-12.238v7.875H10.406a.844.844,0,0,0-.844.844V-.563H1.687V-12.937Z\" transform=\"translate(0 14.625)\" fill=\"#646469\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol